import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipType } from '../../../../../core/betslip-type';
import { isValidOnePickCombo } from '../../../../../core/utils';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class BetslipTypeStateValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override readonly type = CriteriaType.MultiSingleBet;

    constructor(private betslipConfig: BetslipConfig) {
        super();
    }

    isValid(_: IRewardToken, { selectedType, selectedPicks }: TokenValidationInput): boolean {
        switch (selectedType) {
            case BetslipType.Single:
                return selectedPicks.length > 0;

            case BetslipType.Combo:
                return selectedPicks.length > 1 || isValidOnePickCombo(selectedPicks, this.betslipConfig.isSportcastAsComboEnabled);

            case BetslipType.Teaser:
                return selectedPicks.length > 1;

            case BetslipType.BetBuilder:
                return selectedPicks.length > 0;

            default:
                return false;
        }
    }
}
